<template>
  <div class="l-container confirm-info mx-auto">
    <!-- Breadcrumb -->
    <div class="top-title ml-2 font-bold">
      <h3>公開プロフィール</h3>
    </div>
    <a-divider />

    <!-- MAIN -->
    <div class="main-content flex">
      <!-- SIDEBAR -->
      <div class="left-content">
        <LeftMenuBar :navBars="navBars" />
      </div>
      <div class="right-content">
        <div class="block-one-inform">
          <div class="block-one-inform-title">
            <SectionContentTitle
              :lineType="lineType.vertical"
              :titleContent="titleContent[0]"
            />
            <div>
              <button @click="editInfomation" v-if="!isEditInfomation" class="c-btn btn-sm btn-white">
                <span>変更する</span>
              </button>
              <button @click="saveInfomation" v-if="isEditInfomation" class="c-btn btn-sm btn-white">
                <span>保存する</span>
              </button>
            </div>
          </div>
          <div class="block-one-inform-content">
            <div class="inform-line">
              <div class="inform-line-title">氏名</div>
              <div class="inform-line-content">
                <div v-if="!isEditInfomation">{{fullName}}</div>
                <div v-if="isEditInfomation">
                  <a-input :maxLength="100" placeholder="" @blur="trimSpace" v-model="fullName" @change="onChangeFullName"/>
                </div>
                <div class="text-primary font-bold">{{errorMessageName}}</div>
              </div>
            </div>
            <div class="inform-line">
              <div class="inform-line-title">電話番号</div>
              <div class="inform-line-content">
                <div v-if="!isEditInfomation">{{profileInfo.tel}}</div>
                <div v-if="isEditInfomation">
                  <a-input @keypress="validateNumber($event)" :maxLength="11" placeholder="電話番号" v-model="profileInfo.tel" />
                </div>
                <div class="text-primary font-bold">{{errorMessagePhone}}</div>
              </div>
            </div>
            <div class="inform-line">
              <div class="inform-line-title">メールアドレス</div>
              <div class="inform-line-content">
                <div v-if="!isEditInfomation">{{profileInfo.email}}</div>
                <div v-if="isEditInfomation">
                  <a-input :maxLength="255" placeholder="メールアドレス" v-model.trim="profileInfo.email" />
                </div>
                <div class="text-primary font-bold">{{errorMessageEmail}}</div>
              </div>
            </div>
            <div class="inform-line">
              <div class="inform-line-title">住所</div>
              <div class="inform-line-content">
                <div v-if="!isEditInfomation">{{address1}}</div>
                <div v-if="isEditInfomation">
                  <a-input :maxLength="100" placeholder="" v-model.trim="address1" />
                </div>
                <div class="text-primary font-bold">{{errorMessageAddress1}}</div>
              </div>
            </div>
            <div class="inform-line">
              <div class="inform-line-title">アドレス帳</div>
              <div class="inform-line-content">
                <div v-if="!isEditInfomation">{{address2}}</div>
                <div v-if="isEditInfomation">
                  <a-input :maxLength="100" placeholder="" v-model.trim="address2" />
                </div>
                <div class="text-primary font-bold">{{errorMessageAddress2}}</div>
              </div>
            </div>
          </div>

        </div>
        <a-divider />
        <div class="block-two">
          <SectionContentTitle
            :lineType="lineType.vertical"
            :titleContent="titleContent[1]"
          />
          <div class="block-two-content-line">
            <div class="block-two-content-right">
              <div class="block-two-content-title">お気に入りエリア</div>
              <div class="block-two-content-content">{{favoriteArea}}</div>
            </div>
            <div>
              <button @click="showPopupFavorite" class="c-btn btn-sm btn-white">変更する</button>
            </div>
          </div>
          <div class="block-two-content-line">
            <div class="block-two-content-right">
              <div class="block-two-content-title">興味のあるカテゴリ</div>
              <div class="block-two-content-content">
                <span v-for="(item, index) in interestList" :key="`interest-${index}`">[{{item}}] <br></span>
              </div>
            </div>
            <div>
              <button @click="showPopupInterest" class="c-btn btn-sm btn-white">変更する</button>
            </div>
          </div>
        </div>
        <a-divider />
        <div class="block-three-anounce">
          <div class="block-three-anounce-title">
            <SectionContentTitle
              :lineType="lineType.vertical"
              :titleContent="titleContent[2]"
            />
            <div>
              <button @click="editNotification" class="c-btn btn-sm btn-white">
                <span v-if="!isEditNotification">変更する</span>
                <span v-if="isEditNotification">保存する</span>
              </button>
            </div>
          </div>
            <div class="block-three-anounce-content">
              <div class="block-three-anounce-content-title">受信しているメルマガ</div>
              <div class="block-three-anounce-content-content" v-if="isEditNotification">
                <div v-for="(item, index) in anounce_email" :key="`anounce_email-${index}`" class="block-three-anounce-content-line1">
                  <a-checkbox v-model="item.status">{{item.email}}</a-checkbox>
                </div>
              </div>
              <div class="block-three-anounce-content-content" v-if="!isEditNotification">
                <div v-for="(item, index) in anounceEmails" :key="`anounce_email-${index}`" class="block-three-anounce-content-line1">
                  {{item}}
                </div>
              </div>
            </div>
        </div>
        <!-- <a-divider /> -->
        <div class="block-four-credit-card hidden">
          <div class="block-one-inform-title">
            <SectionContentTitle
              :lineType="lineType.vertical"
              :titleContent="titleContent[3]"
            />
            <div><button class="c-btn btn-sm btn-white">確認・変更する</button></div>
          </div>
        </div>
      </div>
    </div>

    <div class="modalFavorite">
      <a-modal :maskClosable="false" v-model="visiblePopupFavorite" :footer="null" class="h-5/6">
        <a-card style="max-width: 640px;" :bordered="false" class="card">
          <div class="title-modal">お気に入りエリア</div>
          <div class="description-modal">お気に入りに入れたいエリア名を入力してください。</div>
          <div class="btn-cms-modal">
            <a-select
              v-model="districtFavorite"
              placeholder=""
              class="mw-select-modal"
            >
              <a-select-option
                v-for="location in favoriteAreas"
                :key="`favorite-area-${location.id}`"
                :value="location.cityName"
              >
                {{ location.cityName }}
              </a-select-option>
            </a-select>
          </div>
          <div class="text-primary font-bold" style="text-align:center;">{{errorMessageFavorite}}</div>
          <div class="btn-cms-modal">
            <button @click="chooseFavorite" class="c-btn c-btn-modal btn-grey">
              <span class="">変更する</span>
            </button>
          </div>
        </a-card>
      </a-modal>
    </div>

    <div class="modalInterest">
      <a-modal :maskClosable="false" v-model="visiblePopupInterest" :footer="null" class="modal">
        <div class="title-modal" >興味のあるカテゴリ</div>
        <div class="item-collapse">
          <a-collapse expandIconPosition="right" >
            <a-collapse-panel v-for="interest_item in interesetLists" :key="interest_item.name" :header="interest_item.name" :style="customStyle_panel">
              <div class="option-list">
                <a-button class="option-btn" v-for="option_item in interest_item.option" :key="option_item.id" @click="changeColor(option_item)" :class="{option_btn_active: option_item.choice  }"><span>{{option_item.value}}</span></a-button>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
        <div class="btn-cms-modal">
            <button @click="chooseInterestList" class="c-btn c-btn-modal btn-grey">
              <span class="">変更する</span>
            </button>
          </div>
      </a-modal>
    </div>

  </div>
</template>
<script>
import { LeftMenuBar, SectionContentTitle } from '@/components/compound'
import { UPDATE_PROFILE, GET_FAVORITE_AREA, GET_FAVORITE_LOCATION,  GET_INTEREST_LIST, ADD_FAVORITE_AREA, ADD_INTEREST_LIST } from '@/store/modules/bs_set/actions'
import { GET_PROFILE } from '@/store/modules/bs_app/actions'
import { anounce_email } from '@/constants/bs_setApp'
import func_utils from '@/mixins/func_utils'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import _ from 'lodash'
import { bus } from '@/main'

export default {
  mixins: [func_utils],
  name: 'BS_SET_02_001',
  components: {
    LeftMenuBar,
    SectionContentTitle
  },
  data() {
    return {
      isEditInfomation: false,
      isEditNotification: false,
      breadcrumb_data: [
        'トップ',
        'マイページ',
        '公開プロフィール'
      ],
      titleContent: ['基本情報', 'お気に入りエリア・興味のあるカテゴリ', 'メール受信・通知', 'クレジットカード'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      fullName: '',
      profileInfo: {
        familyName: '',
        firstName: '',
        tel: '',
        email: '',
        addressUser: {
          addresses: [
            {
              prefectureCode: '',
              address1: '',
              address2: '',
              postalCode: ''
            }
          ]
        }
      },
      anounce_email,
      anounceEmails: [],
      hasError: false,
      error_message: 'メールアドレスを入力してください',
      errorMessageEmail: null,
      errorMessagePhone: null,
      errorMessageName: null,
      errorMessageAddress1: null,
      errorMessageAddress2: null,
      address1: null,
      address2: null,
      defaultDestination: 1,
      prefectureCode: '',
      postalCode: '',

      // value pop up favorite
      visiblePopupFavorite: false,
      favoriteAreas: [],
      favoriteArea: null,
      // pop up interest
      visiblePopupInterest: false,
      interestList: [],
      interesetLists: [],
      customStyle_panel: 'background-color: #ffffff',
      districtFavorite: null,
      errorMessageFavorite: '',
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' }
      ]
    }
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
  },
  created() {
    this.getProfileInfo()
    this.getFavoriteAreaList()
    this.getInterestList()
    this.getFavoriteLocation()
  },
  mounted() {
    // update breadcrumbs
    const mybreadcrumbs =
    {
      path: '/mypage/setting',
      title: '公開プロフィール'
    }
    this.breadcrumbs.push(mybreadcrumbs)
    this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)

  },
  methods: {
    getProfileInfo () {
      this.$store.dispatch(GET_PROFILE).then((data) => {
        if(data !== null) {
          this.profileInfo = data
          this.fullName = `${data.familyName } ${ data.firstName}`
          this.address1 = _.get(this.profileInfo, 'addressUser.addresses[0].address1', '')
          this.address2 = _.get(this.profileInfo, 'addressUser.addresses[0].address2', '')
          this.defaultDestination = _.get(this.profileInfo, 'addressUser.defaultDestination', 1)
          this.prefectureCode = _.get(this.profileInfo, 'addressUser.addresses[0].prefectureCode', 13)
          this.postalCode = _.get(this.profileInfo, 'addressUser.addresses[0].postalCode', 1000000)
        }
      })
    },
    getFavoriteLocation () {
      this.$store.dispatch(GET_FAVORITE_LOCATION).then((data) => {
        if(data !== null) {
          this.favoriteArea = data.interests[0].name
          this.districtFavorite = this.favoriteArea
        }
      })
    },
    getFavoriteAreaList () {
      this.$store.dispatch(GET_FAVORITE_AREA).then((data) => {
        if(data !== null) {
          this.favoriteAreas = data
        }
      })
    },
    getInterestList () {
      this.$store.dispatch(GET_INTEREST_LIST).then((data) => {
        if(data !== null) {
          this.interesetLists = data.categories
          let interestList = []
          // eslint-disable-next-line no-unused-vars
          this.interesetLists.forEach((ele, index) => {
            ele.option.filter(item => item.choice)
            interestList = [...interestList, ...ele.option.filter(item => item.choice)]
          })
          this.interestList = interestList.map(item => item.value)
        }
      })
    },
    editInfomation() {
      this.isEditInfomation = true
    },
    saveInfomation() {
      const hasError =  this.checkMessageError()
      if(!hasError) {
        const fullName = this.fullName.trim()
        const index = fullName.indexOf(' ')
        const email = this.profileInfo.email.trim()
        const profileInfo =   {
          familyName: fullName.substring(0, index),
          firstName: fullName.substring(index + 1, fullName.length),
          familyNameKana: 'タナカ',
          firstNameKana: 'ハナコ',
          birthday: '2000-08-24',
          sex: 1,
          email,
          tel: this.profileInfo.tel,
          secondEmail: 'dung.dinh@amela.vn',
          secondTel: '0344059539',
          loginIdType: 0,
          addressUser: {
            defaultDestination: this.defaultDestination,
            addresses: [
              {
                postalCode: this.postalCode,
                prefectureCode: this.prefectureCode,
                address1: this.address1,
                address2: this.address2
              },
              {
                postalCode: this.postalCode,
                prefectureCode: this.prefectureCode,
                address1: this.address1,
                address2: this.address2
              }
            ]
          },
          addresses: []
        }
        this.$store.dispatch(UPDATE_PROFILE, profileInfo).then(() => {
          this.isEditInfomation = false
          this.fullName = fullName
          this.profileInfo.email = email
          bus.$emit('changeFullName')
        })
      }
    },
    chooseFavorite() {
      if(this.districtFavorite === null) {
        this.errorMessageFavorite = 'お気に入りエリアを入力してください'
      } else {
        this.errorMessageFavorite = ''
        const location = this.favoriteAreas.filter(item => item.cityName === this.districtFavorite)
        const idLocation = location ? location[0].id : ''
        this.$store.dispatch(ADD_FAVORITE_AREA, {interestLocationIds: [idLocation]}).then(() => {
          this.visiblePopupFavorite = false
          this.favoriteArea = this.districtFavorite
        })
      }
    },
    editNotification() {
      this.isEditNotification = !this.isEditNotification
      const anounceEmails = this.anounce_email.filter(item => item.status).map(item => item.email)
      this.anounceEmails = anounceEmails
    },
    checkMessageError() {
      const email = this.profileInfo.email ? this.profileInfo.email.trim() : ''
      let hasError = false
      const isFormatKanji = this.validateTextKanji(this.fullName)
      if (!this.fullName) {
        hasError = true
        this.errorMessageName = '氏名を入力してください'
      } else if(!isFormatKanji) {
        hasError = true
        this.errorMessageName = '氏名の形式が不正です'
      } else {
        this.errorMessageName = ''
      }
      if (this.profileInfo.tel === '') {
        hasError = true
        this.errorMessagePhone = '電話番号を入力してください'
      } else if(!this.validPhone(this.profileInfo.tel) || (this.profileInfo.tel[0] !== '0' && this.profileInfo.tel[0] !== '０')) {
        hasError = true
        this.errorMessagePhone = '有効な電話番号を入力してください'
      } else if(this.profileInfo.tel === this.profileInfo.secondTel) {
        hasError = true
        this.errorMessagePhone = '入力した電話番号は既に存在しますので、再試行してください'
      } else {
        this.errorMessagePhone = ''
      }

      if (email === '') {
        hasError = true
        this.errorMessageEmail = 'メールアドレスを入力してください'
      } else if(!this.validEmail(email)) {
        hasError = true
        this.errorMessageEmail = '有効なメールアドレスを入力してください'
      } else if(email === this.profileInfo.secondEmail) {
        hasError = true
        this.errorMessageEmail = '入力したメールアドレスは既に存在しますので、再試行してください。'
      } else {
        this.errorMessageEmail = ''
      }

      if (!this.address1) {
        hasError = true
        this.errorMessageAddress1 = '住所を入力してください'
      } else {
        this.errorMessageAddress1 = ''
      }

      if (!this.address2) {
        hasError = true
        this.errorMessageAddress2 = 'アドレス帳を入力してください'
      } else {
        this.errorMessageAddress2 = ''
      }

      return hasError
    },
    showPopupFavorite() {
      this.visiblePopupFavorite = true
    },
    showPopupInterest() {
      this.visiblePopupInterest = true
    },
    onChangeFullName(e) {
      const input = e.target.value
      this.fullName = this.onReplaceKanjiRomaji(input)
    },
    chooseInterestList() {
      let data = []
      // eslint-disable-next-line no-unused-vars
      this.interesetLists.forEach((ele, index) => {
        ele.option.filter(item => item.choice)
        data = [...data, ...ele.option.filter(item => item.choice)]
      })
      const interestList = data.map(item => item.value)
      const interestListId = data.map(item => item.id)

      this.$store.dispatch(ADD_INTEREST_LIST, {interestIds: interestListId}).then(() => {
        this.visiblePopupInterest = false
        this.interestList = interestList
      })
    },
    changeColor(option_item) {
      if(option_item.choice === true) {
        option_item.choice = false
        return
      }
      option_item.choice = true
    },
    trimSpace() {
      this.fullName = this.fullName ? this.fullName.trim() : ''
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
